import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { MwAppConfigService } from '../../config/config.service';
import { MwNotificationService } from '../../services/notification.service';
import { MwHttpConfigService } from './config.service';
import { MwUrlService } from './url.service';

@Injectable()
export class AggHttpService {
  constructor(
    public http: HttpClient,
    public httpConfigService: MwHttpConfigService,
    public notificationService: MwNotificationService,
    public translateService: TranslateService,
    public store: Store<any>,
    public urlService: MwUrlService,
    public configService: MwAppConfigService
  ) {}
}
